import { render, staticRenderFns } from "./RecomendedProductsSingleProduct.vue?vue&type=template&id=e3bb6618&scoped=true"
import script from "./RecomendedProductsSingleProduct.vue?vue&type=script&lang=ts"
export * from "./RecomendedProductsSingleProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bb6618",
  null
  
)

export default component.exports